import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

/**
 * Merge Tailwind class names, resolving conflicts via tailwind-merge.
 * Standard Shadcn/UI utility — use for all conditional className assembly.
 * @param {...any} inputs - clsx-compatible inputs (strings, arrays, objects)
 * @returns {string} merged class string
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
